export const GetTodaysDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  //const formattedToday = dd + "/" + mm + "/" + yyyy;
  const formattedToday = yyyy + "/" + mm + "/" + dd;

  return formattedToday;
};

const GetTodaysDateINdmy = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  //const formattedToday = dd + "/" + mm + "/" + yyyy;
  const formattedToday = dd + "/" + mm + "/" + yyyy;

  return formattedToday;
};

export { GetTodaysDateINdmy };

// useEffect(() => {
//   if (location.pathname.includes("journalVoucher")) {

//     function isDate(input) {
//       const pattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
//       return pattern.test(input);
//     }

//     if (isDate(value)) {
//       let [day, month, year] = value.split('/').map(Number);
//       let date = new Date(year, month - 1, day);
//       month = date.getMonth() + 1;
//       day = date.getDate();
//       let formattedDate = `${year}-${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}`;

//       value = formattedDate
//     }
//   }
// }, [value]);
